import { useQuery } from 'react-query';
import { getLocalizationData } from '../services';

export const BASE_KEY = 'get-localization';

export const useLocalizationDataQuery = ({ sellerId, initialData }) => {
    const data = useQuery([BASE_KEY, sellerId], () => getLocalizationData(sellerId), {
        refetchInterval: 20,
        retry: 3,
        initialData,
        enabled: false,
    });

    return data;
};
